import * as React from 'react';
import { useEffect } from 'react';

import { useParams } from 'js/lib/useRouter';

import { trackDegreeEOICompletion } from 'bundles/event-tracking/lib';
import EoiAction from 'bundles/expression-of-interest/components/eoi-v1/EoiAction';
import EoiTosNotice from 'bundles/expression-of-interest/components/eoi-v1/EoiTosNotice';

import 'css!bundles/xddp/components/__styles__/eoi/EoiFooter';

type Props = {
  partnerName?: string;
  responseId: string;
  onNextClick: () => void;
  isTerminalSection?: boolean;
  isQualified: boolean;
  isSubmitting: boolean;
  consentMessage: string;
  nextMessage: string;
  trackingProductId: string;
};

const EoiFooter = ({
  partnerName,
  responseId,
  onNextClick,
  isTerminalSection = false,
  isQualified,
  isSubmitting,
  consentMessage,
  nextMessage,
  trackingProductId,
}: Props): JSX.Element | null => {
  const { slug: programSlug } = useParams();

  useEffect(() => {
    if (isTerminalSection && programSlug) {
      trackDegreeEOICompletion(programSlug, responseId, isQualified);
    }
  }, [isTerminalSection, programSlug, responseId, isQualified]);

  if (isTerminalSection) {
    return null;
  }

  return (
    <div className="rc-EoiFooter">
      <div className="submission-section horizontal-box">
        {partnerName && <EoiTosNotice partnerName={partnerName} consentMessage={consentMessage} />}
        <EoiAction
          isTerminalSection={isTerminalSection}
          isSubmitting={isSubmitting}
          onNextClick={onNextClick}
          message={nextMessage}
          trackingProductId={trackingProductId}
        />
      </div>
    </div>
  );
};

export default EoiFooter;
